import * as React from 'react';
import {
  DARK_PLACEHOLDER,
  getNewValue,
  stringToOptions,
} from '../../../../constants';
import { OptionType, SensorEntry } from '../../../../types';
import InputDropdown from '../../../../widgets/InputDropdown';
import { FilterDropdownProps } from './AdditionalFilterBar';
import { ValueType } from 'react-select/src/types';
import { connect } from 'react-redux';
import { sessionSelector } from '../../../../reducers/session';

type StoreProps = {
  sensors: Array<SensorEntry>;
};

export type Props = StoreProps & FilterDropdownProps;

class SensorFilterDropdown extends React.Component<Props> {
  handleSelectChange = (value: ValueType<OptionType>) => {
    const v = getNewValue(value, true);
    this.props.setFilter(
      this.props.filterKey,
      v && v.map((sel) => sel.value).join(','),
    );
  };

  render() {
    const { sensors, value } = this.props;
    const options = sensors.map((sensor) => ({
      value: sensor.id,
      label: sensor.shorthand,
    }));
    const values = stringToOptions(value, options);

    return (
      <div className="pr-3 pt-3" style={{ minWidth: '200px' }}>
        <h5>Sensor</h5>

        <InputDropdown
          isMulti={true}
          onChange={this.handleSelectChange}
          options={options}
          placeholder="All sensors"
          value={values}
          styles={DARK_PLACEHOLDER}
        />
      </div>
    );
  }
}

export default connect<StoreProps, {}, {}>(
  (store): StoreProps => ({
    sensors: sessionSelector.getSensors(store),
  }),
)(SensorFilterDropdown);
